export default "__VITE_ASSET__a_bT3XYr__"